import { render, staticRenderFns } from "./barebones.vue?vue&type=template&id=1d4ea3b0"
import script from "./barebones.vue?vue&type=script&lang=js"
export * from "./barebones.vue?vue&type=script&lang=js"
import style0 from "./barebones.vue?vue&type=style&index=0&id=1d4ea3b0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports